// src/pages/Home.js
import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom"; // Import NavLink for routing
import './Home.css';
import CertificateSample from '../components/CertificateSample';
import { Helmet } from 'react-helmet';
import Internship from "./internship"; // Ensure the correct import path
import Courses from "./Courses"; // Ensure the correct import path
import Enroll from "./enroll";

import { FaGraduationCap, FaLaptopCode, FaBriefcase, FaPalette, FaChartLine, FaUserTie, FaGlobe, FaHandshake, FaBookOpen, FaCertificate, FaClock } from 'react-icons/fa';
import { IoMdRocket } from 'react-icons/io';
import { GiSkills } from 'react-icons/gi';
import { MdScience, MdEngineering, MdBusinessCenter, MdDesignServices } from 'react-icons/md';



const Home = () => {
  const videoRef = useRef(null);

  // Toggle Play/Pause for the video
  const toggleVideo = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  useEffect(() => {
    const courseList = document.getElementById('courseList');
    // Pause the scroll on hover
    const pauseScroll = () => {
      courseList.style.animationPlayState = 'paused';
    };

    const resumeScroll = () => {
      courseList.style.animationPlayState = 'running';
    };

    courseList.addEventListener('mouseover', pauseScroll);
    courseList.addEventListener('mouseout', resumeScroll);

    return () => {
      courseList.removeEventListener('mouseover', pauseScroll);
      courseList.removeEventListener('mouseout', resumeScroll);
    };
  }, []);

  return (
    <div className="home">
      <Helmet>
        {/* Basic Meta Tags */}
        <title>InternCourse Pvt. Ltd.</title>
        <meta name="description" content="InternCourse is the leading platform for online learning, offering affordable and high-quality courses in software development, web development, Java, Python, and more. Start learning today!" />
        <meta name="keywords" content="InternCourse, Intern Course, Course Intern, Internship, Internship Certificates, online learning, e-learning, software development, Java courses, Python courses, web development, digital education, learn programming online" />
        <meta name="google-adsense-account" content="ca-pub-3362077298392685" />

        {/* Open Graph Meta Tags (for social media) */}
        <meta property="og:title" content="InternCourse - Learn Software Development & More Online" />
        <meta property="og:description" content="InternCourse offers top-quality online courses in software development, web development, Java, Python, and other tech skills. Start your learning journey today!" />
        <meta property="og:image" content="https://interncourse.online/images/head.WebP" />
        <meta property="og:url" content="https://interncourse.online" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="InternCourse" />

        {/* Twitter Card Meta Tags (for Twitter sharing) */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="InternCourse - Affordable Online Courses for All" />
        <meta name="twitter:description" content="Learn software development, Java, Python, web development, and more with InternCourse. Start your online learning journey today!" />
        <meta name="twitter:image" content="https://interncourse.online/images/head.WebP" />
        <meta name="twitter:site" content="@InternCourse" />

        {/* Canonical Link (to prevent duplicate content) */}
        <link rel="canonical" href="https://interncourse.online" />

        {/* Structured Data (for rich snippets) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "InternCourse",
            "url": "https://interncourse.online",
            "logo": "https://interncourse.online/images/logo.png",
            "sameAs": [
              "https://www.facebook.com/InternCourse",
              "https://www.instagram.com/InternCourse",
              "https://twitter.com/InternCourse",
              "https://www.linkedin.com/company/interncourse"
            ],
           
          })}
        </script>
      </Helmet>
<section style={{
  backgroundColor: '#f3f4f6',
  padding: '3rem 1rem',
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
}}>
  <div style={{
    maxWidth: '1100px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '1.5rem',
    alignItems: 'start'
  }}>

    {/* Left Column Stack */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      
      {/* Top Left: Get Started Blue Card */}
      <div style={{
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        borderRadius: '24px',
        padding: '2rem',
        color: '#ffffff',
        position: 'relative',
        boxShadow: '0 12px 30px rgba(37, 99, 235, 0.25)',
        display: 'flex',
        flexDirection: 'column',
        justify: 'space-between'
      }}>
        {/* Card Header Tag */}
        <div style={{
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem'
        }}>
           </div>

        {/* Content */}
        <div>
          <div style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span>👋</span> Welcome to InternCourse!
          </div>
          <h2 style={{ fontSize: '2rem', fontWeight: '800', lineHeight: 1.2, margin: '0 0 1.75rem 0', letterSpacing: '-0.02em' }}>
            Start Your Career Journey The Right Way
          </h2>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <a href="/enroll" style={{
            backgroundColor: '#ffffff',
            color: '#1d4ed8',
            padding: '0.75rem 1.25rem',
            borderRadius: '9999px',
            fontWeight: '700',
            fontSize: '0.9rem',
            textDecoration: 'none',
            boxShadow: '0 4px 14px rgba(0, 0, 0, 0.1)'
          }}>
            ✨ Register Here
          </a>
          
        </div>
      </div>

      {/* Bottom Left: Reviews & Stats White Card */}
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '1.75rem',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
        border: '1px solid #e5e7eb'
      }}>
        <div style={{
          fontSize: '0.75rem',
          fontWeight: '800',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: '#1f2937',
          marginBottom: '1.25rem'
        }}>
          Reviews & Stats
        </div>

        {/* Numbers Row */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '1rem',
          alignItems: 'center',
          borderBottom: '1px solid #f3f4f6',
          paddingBottom: '1.25rem',
          marginBottom: '1.25rem'
        }}>
          <div>
            <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#111827', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
              4.9 <span style={{ color: '#eab308', fontSize: '1.2rem' }}>★</span>
            </div>
            <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Rating Students</div>
          </div>

          <div>
            <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#111827' }}>12K+</div>
            <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Happy Students</div>
          </div>

          <div>
            <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#111827' }}>12+</div>
            <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Career Fields</div>
          </div>
        </div>

        {/* Testimonial Quote */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{ display: 'flex', marginLeft: '0.5rem' }}>
            <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#cbd5e1', border: '2px solid #fff' }}></div>
            <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#94a3b8', border: '2px solid #fff', marginLeft: '-8px' }}></div>
            <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#64748b', border: '2px solid #fff', marginLeft: '-8px' }}></div>
          </div>
          <div style={{ fontSize: '0.85rem', color: '#374151', fontWeight: '500' }}>
            💬 "Best decision I made!" <span style={{ color: '#9ca3af' }}>— Alex R.</span>
          </div>
        </div>
      </div>

    </div>

    {/* Right Column: Visual Feature Box */}
    <div style={{
      backgroundColor: '#ffffff',
      borderRadius: '24px',
      padding: '1.25rem',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
      border: '1px solid #e5e7eb',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <div style={{
        fontSize: '0.75rem',
        fontWeight: '800',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#1f2937',
        paddingLeft: '0.5rem'
      }}>
        Internships & Skills
      </div>

      {/* Image Block with Floating Badges */}
      <div style={{
        position: 'relative',
        borderRadius: '16px',
        overflow: 'hidden',
        minHeight: '380px'
      }}>
        <img 
          src="/images/intern.jpg" 
          alt="Students learning together" 
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', position: 'absolute' }}
        />

        {/* Top Badges */}
        <div style={{
          position: 'absolute',
          top: '16px',
          left: '16px',
          display: 'flex',
          gap: '0.5rem',
          flexWrap: 'wrap'
        }}>
          <span style={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(8px)',
            padding: '0.4rem 0.8rem',
            borderRadius: '9999px',
            fontSize: '0.8rem',
            fontWeight: '600',
            color: '#1f2937'
          }}>
            👋 Real Experience
          </span>
          <span style={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(8px)',
            padding: '0.4rem 0.8rem',
            borderRadius: '9999px',
            fontSize: '0.8rem',
            fontWeight: '600',
            color: '#15803d'
          }}>
            ✔ Verified Programs
          </span>
        </div>

        {/* Bottom Skill Tags */}
        <div style={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          right: '16px',
          display: 'flex',
          gap: '0.5rem',
          flexWrap: 'wrap'
        }}>
          <span style={{
            backgroundColor: 'rgba(15, 23, 42, 0.75)',
            backdropFilter: 'blur(8px)',
            color: '#ffffff',
            padding: '0.4rem 0.8rem',
            borderRadius: '9999px',
            fontSize: '0.8rem',
            fontWeight: '500'
          }}>
            💻 Tech
          </span>
          <span style={{
            backgroundColor: 'rgba(15, 23, 42, 0.75)',
            backdropFilter: 'blur(8px)',
            color: '#ffffff',
            padding: '0.4rem 0.8rem',
            borderRadius: '9999px',
            fontSize: '0.8rem',
            fontWeight: '500'
          }}>
            ✏️ Design
          </span>
          <span style={{
            backgroundColor: 'rgba(15, 23, 42, 0.75)',
            backdropFilter: 'blur(8px)',
            color: '#ffffff',
            padding: '0.4rem 0.8rem',
            borderRadius: '9999px',
            fontSize: '0.8rem',
            fontWeight: '500'
          }}>
            📢 Marketing
          </span>
        </div>
      </div>
    </div>

  </div>
</section>







{/* Enhanced Fields Section */}
<section id="fields" style={{
  backgroundColor: '#f8fafc',
  padding: '4rem 1.25rem',
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
}}>
  <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
    
    {/* Section Header */}
    <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem',
        backgroundColor: '#e0e7ff',
        color: '#4338ca',
        padding: '0.4rem 1rem',
        borderRadius: '9999px',
        fontSize: '0.85rem',
        fontWeight: '600',
        marginBottom: '1rem',
        border: '1px solid #c7d2fe'
      }}>
        <GiSkills style={{ fontSize: '1rem' }} /> Explore Pathways
      </div>

      <h2 style={{
        fontSize: 'clamp(1.875rem, 4vw, 2.5rem)',
        fontWeight: '800',
        color: '#0f172a',
        margin: '0 0 0.75rem 0',
        lineHeight: 1.2,
        letterSpacing: '-0.02em'
      }}>
        Our <span style={{
          background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>Internship Programs</span>
      </h2>

      <p style={{
        color: '#64748b',
        fontSize: '1rem',
        margin: '0 auto',
        maxWidth: '560px',
        lineHeight: 1.5
      }}>
        Choose from specialized programs designed to give you practical, employable skills and real-world project experience.
      </p>
    </div>

    {/* Bento Card Grid */}
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '1.5rem',
      alignItems: 'stretch'
    }}>
      
      {/* Card 1: Medical */}
      <div style={{
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '20px',
        padding: '1.75rem',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)',
        display: 'flex',
        flexDirection: 'column',
        justify: 'space-between'
      }}>
        <div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#ecfdf5',
            color: '#059669',
            display: 'flex',
            alignItems: 'center',
            justify: 'center',
            fontSize: '1.5rem',
            marginBottom: '1.25rem'
          }}>
            <MdScience />
          </div>
          <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a', margin: '0 0 0.5rem 0' }}>
            Medical & Healthcare
          </h3>
          <p style={{ color: '#64748b', fontSize: '0.875rem', lineHeight: 1.5, margin: '0 0 1.25rem 0' }}>
            Clinical research, medical writing, hospital administration, and lab training programs.
          </p>
          
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem 0', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <FaChartLine style={{ color: '#059669' }} /> Hospital Placement Assistance
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <FaBookOpen style={{ color: '#059669' }} /> Research Publication Support
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <MdScience style={{ color: '#059669' }} /> Practical Lab Sessions
            </li>
          </ul>
        </div>

        <a href="#contact" style={{
          display: 'inline-flex',
          alignItems: 'center',
          justify: 'center',
          gap: '0.5rem',
          backgroundColor: '#f1f5f9',
          color: '#334155',
          padding: '0.75rem 1rem',
          borderRadius: '10px',
          textDecoration: 'none',
          fontWeight: '600',
          fontSize: '0.875rem'
        }}>
          Get Details <FaHandshake />
        </a>
      </div>

      {/* Card 2: Engineering & Tech */}
      <div style={{
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '20px',
        padding: '1.75rem',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)',
        display: 'flex',
        flexDirection: 'column',
        justify: 'space-between'
      }}>
        <div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#eff6ff',
            color: '#2563eb',
            display: 'flex',
            alignItems: 'center',
            justify: 'center',
            fontSize: '1.5rem',
            marginBottom: '1.25rem'
          }}>
            <MdEngineering />
          </div>
          <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a', margin: '0 0 0.5rem 0' }}>
            Engineering & Tech
          </h3>
          <p style={{ color: '#64748b', fontSize: '0.875rem', lineHeight: 1.5, margin: '0 0 1.25rem 0' }}>
            Full-stack development, AI/ML, IoT, Cybersecurity, and Data Science intensive tracks.
          </p>
          
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem 0', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <FaLaptopCode style={{ color: '#2563eb' }} /> Real-world Tech Projects
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <FaGlobe style={{ color: '#2563eb' }} /> AI Startup Challenges
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <FaBriefcase style={{ color: '#2563eb' }} /> Portfolio Development
            </li>
          </ul>
        </div>

        <a href="#contact" style={{
          display: 'inline-flex',
          alignItems: 'center',
          justify: 'center',
          gap: '0.5rem',
          backgroundColor: '#f1f5f9',
          color: '#334155',
          padding: '0.75rem 1rem',
          borderRadius: '10px',
          textDecoration: 'none',
          fontWeight: '600',
          fontSize: '0.875rem'
        }}>
          Get Details <FaHandshake />
        </a>
      </div>

      {/* Card 3: Featured Business Card */}
      <div style={{
        background: 'linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)',
        borderRadius: '20px',
        padding: '1.75rem',
        color: '#ffffff',
        boxShadow: '0 12px 30px rgba(79, 70, 229, 0.3)',
        display: 'flex',
        flexDirection: 'column',
        justify: 'space-between',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Featured Badge */}
        <div style={{
          position: 'absolute',
          top: '1rem',
          right: '1rem',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(4px)',
          color: '#ffffff',
          fontSize: '0.7rem',
          fontWeight: '700',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          padding: '0.25rem 0.6rem',
          borderRadius: '9999px',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }}>
          Most Popular
        </div>

        <div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justify: 'center',
            fontSize: '1.5rem',
            marginBottom: '1.25rem'
          }}>
            <MdBusinessCenter />
          </div>
          <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#ffffff', margin: '0 0 0.5rem 0' }}>
            Business & Management
          </h3>
          <p style={{ color: '#c7d2fe', fontSize: '0.875rem', lineHeight: 1.5, margin: '0 0 1.25rem 0' }}>
            Digital marketing, financial analysis, HR strategies, and entrepreneurship programs.
          </p>
          
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem 0', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#e0e7ff', fontWeight: '500' }}>
              <FaChartLine style={{ color: '#818cf8' }} /> Live Case Studies
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#e0e7ff', fontWeight: '500' }}>
              <IoMdRocket style={{ color: '#818cf8' }} /> Startup Incubation
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#e0e7ff', fontWeight: '500' }}>
              <FaGlobe style={{ color: '#818cf8' }} /> Global Business Sims
            </li>
          </ul>
        </div>

        <a href="#contact" style={{
          display: 'inline-flex',
          alignItems: 'center',
          justify: 'center',
          gap: '0.5rem',
          backgroundColor: '#ffffff',
          color: '#3730a3',
          padding: '0.75rem 1rem',
          borderRadius: '10px',
          textDecoration: 'none',
          fontWeight: '700',
          fontSize: '0.875rem',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
          Get Details <FaHandshake />
        </a>
      </div>

      {/* Card 4: Creative & Design */}
      <div style={{
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '20px',
        padding: '1.75rem',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)',
        display: 'flex',
        flexDirection: 'column',
        justify: 'space-between'
      }}>
        <div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#fdf2f8',
            color: '#db2777',
            display: 'flex',
            alignItems: 'center',
            justify: 'center',
            fontSize: '1.5rem',
            marginBottom: '1.25rem'
          }}>
            <MdDesignServices />
          </div>
          <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a', margin: '0 0 0.5rem 0' }}>
            Creative & Design
          </h3>
          <p style={{ color: '#64748b', fontSize: '0.875rem', lineHeight: 1.5, margin: '0 0 1.25rem 0' }}>
            UI/UX design, graphic design, motion graphics, and branding specialization.
          </p>
          
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem 0', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <FaPalette style={{ color: '#db2777' }} /> Adobe Creative Suite
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <GiSkills style={{ color: '#db2777' }} /> Design Thinking Workshops
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.85rem', color: '#334155', fontWeight: '500' }}>
              <FaLaptopCode style={{ color: '#db2777' }} /> App Design Challenges
            </li>
          </ul>
        </div>

        <a href="#contact" style={{
          display: 'inline-flex',
          alignItems: 'center',
          justify: 'center',
          gap: '0.5rem',
          backgroundColor: '#f1f5f9',
          color: '#334155',
          padding: '0.75rem 1rem',
          borderRadius: '10px',
          textDecoration: 'none',
          fontWeight: '600',
          fontSize: '0.875rem'
        }}>
          Get Details <FaHandshake />
        </a>
      </div>

    </div>
  </div>
</section>














{/* Enhanced Why Choose Section with Icons */}
<section className="why-best">
  <div className="section-header">
    <h2 className="section-title">Why <span className="text-gradient">InternCourse</span>?</h2>
    <p className="section-description">
      <FaGraduationCap className="section-icon" /> We don't just offer internships - we create career transformation experiences
    </p>
  </div>

  <div className="features-grid">
    <div className="feature-card">
      <div className="feature-icon"><FaLaptopCode /></div>
      <h3>Project-Based Learning</h3>
      <p>Work on real client projects that solve actual business problems, not just theoretical exercises.</p>
    </div>
    
    <div className="feature-card">
      <div className="feature-icon"><FaUserTie /></div>
      <h3>Industry Mentor Matching</h3>
      <p>Get paired with a mentor currently working in your target role at top companies.</p>
    </div>
    
    <div className="feature-card">
      <div className="feature-icon"><FaBriefcase /></div>
      <h3>Career Accelerator</h3>
      <p>Includes resume workshops, LinkedIn optimization, and mock interviews with HR professionals.</p>
    </div>
    
    <div className="feature-card">
      <div className="feature-icon"><FaGlobe /></div>
      <h3>Global Recognition</h3>
      <p>Our certificates are recognized by 100+ employers worldwide with verification portal access.</p>
    </div>
    
    <div className="feature-card">
      <div className="feature-icon"><FaHandshake /></div>
      <h3>Job Pipeline</h3>
      <p>Top performers get referred to our hiring partners with priority consideration.</p>
    </div>
    
    <div className="feature-card">
      <div className="feature-icon"><FaClock /></div>
      <h3>Lifetime Access</h3>
      <p>Continue accessing updated resources and our alumni network even after completion.</p>
    </div>
  </div>
</section>



{/* Courses Section */}
<section className="courses">
<h2>
    <a href="courses">Popular Courses</a>
  </h2>
  <div className="course-list" id="courseList">
    {/* Web Development */}
    <div className="course-item">
      <img src="/images/webdev.jpg" alt="Web Development" className="course-image" />
      <h4>Web Development</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/web-development" className="details-link">More Details</a>
    </div>

    {/* Revit */}
    <div className="course-item">
      <img src="/images/revit.jpg" alt="Revit" className="course-image" />
      <h4>Revit</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/revit" className="details-link">More Details</a>
    </div>

    {/* SCADA */}
    <div className="course-item">
      <img src="/images/scada.jpg" alt="SCADA" className="course-image" />
      <h4>SCADA</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/scada" className="details-link">More Details</a>
    </div>

    {/* ANSYS */}
    <div className="course-item">
      <img src="/images/ansys.jpg" alt="ANSYS" className="course-image" />
      <h4>ANSYS</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/ansys" className="details-link">More Details</a>
    </div>

    {/* Chatbot */}
    <div className="course-item">
      <img src="/images/chat.jpg" alt="Chatbot" className="course-image" />
      <h4>Chatbot</h4>
      <p>Duration: 06 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/chatbot" className="details-link">More Details</a>
    </div>

    {/* Data Science */}
    <div className="course-item">
      <img src="/images/data.WebP" alt="Data Science" className="course-image" />
      <h4>Data Science</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/data-science" className="details-link">More Details</a>
    </div>

    {/* Artificial Intelligence */}
    <div className="course-item">
      <img src="/images/ai.jpg" alt="Artificial Intelligence" className="course-image" />
      <h4>Artificial Intelligence</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/artificial-intelligence" className="details-link">More Details</a>
    </div>

    {/* Cybersecurity */}
    <div className="course-item">
      <img src="/images/cyber.jpg" alt="Cybersecurity" className="course-image" />
      <h4>Cybersecurity</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/cybersecurity" className="details-link">More Details</a>
    </div>

    {/* Database Management */}
    <div className="course-item">
      <img src="/images/base.jpg" alt="Database Management" className="course-image" />
      <h4>Database Management</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/database-management" className="details-link">More Details</a>
    </div>

    {/* Python */}
    <div className="course-item">
      <img src="/images/python.jpg" alt="Python" className="course-image" />
      <h4>Python</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/python" className="details-link">More Details</a>
    </div>

    {/* Java */}
    <div className="course-item">
      <img src="/images/java.jpg" alt="Java" className="course-image" />
      <h4>Java</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/java" className="details-link">More Details</a>
    </div>

    {/* C++ */}
    <div className="course-item">
      <img src="/images/cp.jpg" alt="C++" className="course-image" />
      <h4>C++</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/cpp" className="details-link">More Details</a>
    </div>

    {/* C Programming */}
    <div className="course-item">
      <img src="/images/c.jpg" alt="C Programming" className="course-image" />
      <h4>C Programming</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/c-programming" className="details-link">More Details</a>
    </div>

    {/* JavaScript */}
    <div className="course-item">
      <img src="/images/script.jpg" alt="JavaScript" className="course-image" />
      <h4>JavaScript</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/javascript" className="details-link">More Details</a>
    </div>

    {/* STAAD PRO */}
    <div className="course-item">
      <img src="/images/staad.jpg" alt="STAAD PRO" className="course-image" />
      <h4>STAAD PRO</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/staad-pro" className="details-link">More Details</a>
    </div>

    {/* ETABS */}
    <div className="course-item">
      <img src="/images/etabs.jpg" alt="ETABS" className="course-image" />
      <h4>ETABS</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/etabs" className="details-link">More Details</a>
    </div>

    {/* BIM */}
    <div className="course-item">
      <img src="/images/bim.jpg" alt="BIM" className="course-image" />
      <h4>BIM</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/bim" className="details-link">More Details</a>
    </div>

    {/* AutoCAD */}
    <div className="course-item">
      <img src="/images/autocad-2016-1.jpg" alt="AutoCAD" className="course-image" />
      <h4>AutoCAD</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/autocad" className="details-link">More Details</a>
    </div>

    {/* MATLAB */}
    <div className="course-item">
      <img src="/images/mat.jpg" alt="MATLAB" className="course-image" />
      <h4>MATLAB</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/matlab" className="details-link">More Details</a>
    </div>

    {/* IOT */}
    <div className="course-item">
      <img src="/images/iot.jpg" alt="IOT" className="course-image" />
      <h4>IOT</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/iot" className="details-link">More Details</a>
    </div>

    {/* HVAC */}
    <div className="course-item">
      <img src="/images/hvac.jpg" alt="HVAC" className="course-image" />
      <h4>HVAC</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/hvac" className="details-link">More Details</a>
    </div>

    {/* CATIA */}
    <div className="course-item">
      <img src="/images/catia.jpg" alt="CATIA" className="course-image" />
      <h4>CATIA</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/catia" className="details-link">More Details</a>
    </div>

    {/* SOLIDWORKS */}
    <div className="course-item">
      <img src="/images/solid.jpg" alt="SOLIDWORKS" className="course-image" />
      <h4>SOLIDWORKS</h4>
      <p>Duration: 08 Weeks</p>
      <p className="old-price">₹1499</p>
      <p className="new-price">₹899</p>
      <a href="/course-details/solidworks" className="details-link">More Details</a>
    </div>
  </div>
</section>




<Internship />





 <section className="demo-classes-section">
  <h2 className="demo-classes-title">Demo Classes</h2>
  <div className="demo-classes-container">
    <div className="demo-class-card">
      <div className="video-wrapper">
        <video className="demo-class-video" ref={videoRef} controls>
          <source src="/videos/demo1.mp4" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>
      <p className="demo-class-name">Class 0: Introduction to ANSYS</p>
      <button className="demo-class-button" onClick={toggleVideo}>
        Play/Pause
      </button>
    </div>
    <div className="demo-class-card">
      <div className="video-wrapper">
        <video className="demo-class-video" ref={videoRef} controls>
          <source src="/videos/demo2.mp4" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>
      <p className="demo-class-name">Class 0: Introduction to STAAD.PRO</p>
      <button className="demo-class-button" onClick={toggleVideo}>
        Play/Pause
      </button>
    </div>
  </div>
</section>




<Enroll />

    

{/* Add the Courses Section Here */}
<Courses />


    <section className="circular-images-section">
      <h2>Registered </h2> {/* Optional heading */}
      <div className="circular-images-container">
        <div className="circular-image">
          <img src="images/AICTE.jpg" alt="AICTE" />
        </div>
        <div className="circular-image">
          <img src="images/MCA.jpg" alt="MCA" />
        </div>
        <div className="circular-image">
          <img src="images/BIHAR.jpg" alt="BIHAR STARTUP" />
        </div>
        <div className="circular-image">
          <img src="images/startupind.png" alt="STARTUP INDIA" />
        </div>


        <div className="circular-image">
          <img src="images/ISO.jpg" alt="ISO" />
        </div>
        <div className="circular-image">
          <img src="images/MSME.jpg" alt="MSME" />
      
        </div>
        {/* Add more circular images as needed */}
      </div>
    </section>



      
    </div>
  );
};

export default Home;
